module.exports = __webpack_public_path__ + "img/深圳南山医院.ff7bd00e.png";